const { head, pipe, prop } = require("ramda");

module.exports = pipe(prop("rows"), head);
